module.exports = __webpack_public_path__ + "static/media/frothluxe-4.02a7bdf8.jpg";